import { render } from "./AssignView.vue?vue&type=template&id=b0775b16"
import script from "./AssignView.vue?vue&type=script&lang=js"
export * from "./AssignView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__